<template>
  <el-row class="login-page mt-3" justify="top">
    <el-col align="center" :span="24">
      <h1>Cultura</h1>
      <h2 class="pt-3">Nosso Jeito de Ser e Fazer</h2>
      <el-image class="logo mt-5 mb-3" src="images/logo-pixeon-icone.png" />

      <div class="login-form">
        <el-form @submit.prevent>
          <!-- <el-form-item>
            <el-input
              type="email"
              input-style="border-radius: 3rem;"
              placeholder="Please input your email"
              v-model.trim="authForm.email"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-input
              input-style="border-radius: 3rem;"
              placeholder="Please input password"
              v-model.trim="authForm.password"
              show-password
            ></el-input>
          </el-form-item> -->

          <button
              class="btn-login"
              type="primary"
              @click="handleMicrosoftLogin"
              round
            >
              Login
            </button>
        </el-form>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { useRouter } from 'vue-router'
import { ref } from 'vue'
import { getAuth, signInWithEmailAndPassword, OAuthProvider, signInWithPopup } from 'firebase/auth'
import { getDatabase, ref as dbRef, get, child, set } from 'firebase/database'
import { ElMessage } from 'element-plus'

export default {
  name: 'Login',
  setup () {
    const router = useRouter()
    const auth = getAuth()
    const dbSet = getDatabase()
    const dbGet = dbRef(getDatabase())

    const handleMicrosoftLogin = () => {
      const provider = new OAuthProvider('microsoft.com')
      signInWithPopup(auth, provider).then(result => {
        const credential = OAuthProvider.credentialFromResult(result)
        console.log(credential)
      })
    }

    const authForm = ref({
      email: '',
      password: ''
    })

    const loginUser = () => {
      signInWithEmailAndPassword(auth, authForm.value.email, authForm.value.password)
        .then((userCredential) => {
          const payload = {
            userId: userCredential.user.uid,
            email: userCredential.user.email,
            active: true,
            firstAccess: true
          }
          get(child(dbGet, `users/${payload.userId}`)).then((snapshot) => {
            if (snapshot.exists()) {
              const user = snapshot.val()
              payload.active = user.active
              if (!user.active) {
                auth.signOut()
                return
              }
              if (user.firstAccess) router.push('/mudar-senha')
            } else {
              set(dbRef(dbSet, `users/${payload.userId}`), {
                email: payload.email,
                active: payload.active,
                firstAccess: payload.firstAccess
              })
              router.push('/mudar-senha')
            }
          }).catch((error) => {
            console.log(error)
          })
        }).catch(() => {
          ElMessage({
            message: 'Usuário e/ou senha incorretos',
            type: 'error'
          })
        })
    }

    return {
      authForm,
      loginUser,
      handleMicrosoftLogin
    }
  }
}
</script>

<style lang="scss">
.login-page {
  justify-content: space-around;
  height: 100vh;
}
</style>

<style lang="scss" scoped>

.logo {
  height: 8rem;
}

.login-form {
  max-width: 40rem;
}

.btn-position {
  position: absolute;
  right: 0;
  top: -5px;
}
</style>
